import { Route } from "@/shared/domain/routes";

const refund = {
  root: {
    url: "/refund",
    name: "refund",
    meta: { isPage: true },
  },
  init: {
    url: "/refund/init",
    name: "refund-init",
    meta: { isPage: true },
  },
  contract: {
    url: "/refund/contract",
    name: "refund-contract",
    meta: { isPage: false },
  },
  setting: {
    url: "/refund/setting",
    name: "refund-setting",
    meta: { isPage: true },
  },
  receipt: {
    url: "/refund/receipt",
    name: "refund-receipt",
    meta: { isPage: true },
  },
  wallet: {
    url: "/refund/wallet",
    name: "refund-wallet",
    meta: { isPage: true },
  },
  walletTransactions: {
    url: "/refund/wallet/transactions",
    name: "refund-wallet-transactions",
    meta: { isPage: false },
  },
  walletDeposit: {
    url: "/refund/wallet/deposit",
    name: "refund-wallet-deposit",
    meta: { isPage: false },
  },
} as const satisfies Route;

export default refund;
